import React, { useRef, useState, useEffect } from "react";
import Layout from "../Common/Layout";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const DoForm2 = () => {
  const [kataSlips, setKataSlips] = useState([]);

  const deliveryorder = JSON.parse(sessionStorage.getItem("deliveryorder"));
 
  const sessionDate = deliveryorder.date || "";
  const [totalBags, setTotalBags] = useState(0);


  console.log(deliveryorder.doNo);

  const [client, setClient] = useState();

  const token = sessionStorage.getItem("token");

  const fetchClient = async () => {
    try {
      const res = await axios.get(
        `https://irc.zentelex.com/api/delivery-order/by-cdd/${deliveryorder?.cddNo}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      // Save API response in state
      setClient(res.data.data);
    } catch (error) {
      console.error("Error fetching client:", error);
    }
  };

  useEffect(() => {
    if (deliveryorder?.cddNo) {
      fetchClient();
    }
  }, [deliveryorder?.cddNo]);

  const fetchKataSlipBagsByCDD = async (cddNo) => {
    try {
      const res = await axios.get(
        `https://irc.zentelex.com/api/kataslip/kataslip/cdd/${cddNo}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const slips = res.data?.data || [];

      setKataSlips(slips); // 🔥 store full list for table

      console.log("Kataslip Data:", slips);

      // 🔥 SUM no of bags
      const sumBags = slips.reduce(
        (total, item) => total + Number(item.no_of_bags || item.noOfBags || 0),
        0,
      );

      // 🔥 SUM weight
      const sumWeight = slips.reduce(
        (total, item) => total + Number(item.weight || item.netWt || 0),
        0,
      );

      // 🔁 Round weight (optional)
      const weightRounded = Number(sumWeight).toFixed(2);

      // ✅ Update states
      setTotalBags(sumBags);

      setFormData((prev) => ({
        ...prev,
        NoOfPack: sumBags, // ✅ correct key
        weighment: weightRounded,
      }));
    } catch (error) {
      console.error("Error fetching kataslip by CDD:", error);
    }
  };

  useEffect(() => {
    if (deliveryorder?.cddNo) {
      fetchKataSlipBagsByCDD(deliveryorder?.cddNo);
    }
  }, [deliveryorder?.cddNo]);

  console.log(client);

  useEffect(() => {
    const gp = sessionStorage.getItem("gatepass");
    if (gp) {
      setFormData((prev) => ({
        ...prev,
        gatePassNo: gp,
      }));
    }
  }, []);

  const formRef = useRef();
  const navigate = useNavigate();

  const [formdata, setFormData] = useState({
    cddNo: "",
    Date: sessionDate,
    WarehouseName: "",
    WarehouseAddress: "",
    LocationName: "",
    ClientName: "",
    ClientAddress: "",
    NameofReceipent: "",
    recepientProof: "",
    IdNo: "",
    commodityName: "",
    variety: "",
    serial: "",
    DoNo: deliveryorder.doNo,
    DoDate: sessionDate,
    NoOfPack: "",
    weighment: "",
    godownChamber: "",
    Remarks: "",
    gatePassNo: "",
    weighBridgeName: "",
    clientName: "",
  });

  /* ================= FETCH API DATA ================= */

  const safe = (v) => v ?? "";

  useEffect(() => {
    if (client) {
      setFormData((prev) => ({
        ...prev,

        // 🔹 map API keys → form fields
        ClientName: safe(client.clientName),
        commodityName: safe(client.commodity),
        variety: safe(client.variety),
        ClientAddress: safe(client.clientAddress),
        WarehouseName: safe(client.warehouse),
        cddNo: safe(client.cdd_no || client.cddNo || deliveryorder?.cddNo),
        weighBridgeName: safe(client.weighBridgeName),
        NameofReceipent: safe(client.buyer),
        WarehouseAddress: safe(client.warehouseAddress),
        remarks: safe(client.remarks),
      }));
    }
  }, [client]);

  const handleChange = (e) => {
    setFormData({ ...formdata, [e.target.id]: e.target.value });
  };

  const handlePrint = () => {
    const printContents = formRef.current.innerHTML;
    const printWindow = window.open("", "_blank", "width=900,height=650");

    printWindow.document.write(`
    <html>
      <head>
        <title>CDD Receipt</title>
        <style>
          body { font-family: Arial; padding: 20px; }
          table { width: 100%; border-collapse: collapse; }
          td, th { border: 1px solid #000; padding: 6px; }
          h2, h3 { text-align: center; }
          input, textarea {
            border: none;
            outline: none;
            width: 100%;
          }
        </style>
      </head>
      <body>${printContents}</body>
    </html>
  `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        cdd_no: formdata.cddNo,
        documentDate: formdata.Date,

        warehouseName: formdata.WarehouseName,
        locationName: formdata.LocationName,
        warehouseAddress: formdata.WarehouseAddress,

        clientName: formdata.ClientName,
        clientAddress: formdata.ClientAddress,

        recipientName: formdata.NameofReceipent,
        proofType: formdata.recepientProof,
        recipientIdNo: formdata.IdNo,

        commodityName: formdata.commodityName,
        variety: formdata.variety,

        do_no: formdata.DoNo,
        doDate: formdata.DoDate,
        noOfPack: formdata.NoOfPack,
        weightMt: formdata.weighment,

        chamber: formdata.godownChamber,
        gatePassNo: formdata.gatePassNo,
        weighBridgeName: formdata.weighBridgeName,

        clientSignatoryName: formdata.clientName,
        remarks: formdata.Remarks,

        truckDetails: kataSlips.map((truck) => ({
          truckNo: truck.vehicleType || "",
          weightPerTruck:
            truck.weight_per_truck || truck.weight || truck.netWt || 0,
          noOfBags: truck.no_of_bags || truck.noOfBags || 0,
        })),
      };

      await axios.post(
        "https://irc.zentelex.com/api/cdd-receipts/create",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      toast.success("✅ CDD saved successfully!", {
        autoClose: 2000,
        theme: "colored",
      });

      setTimeout(() => {
        handlePrint();
      }, 500);

      sessionStorage.removeItem("deliveryorder");
    } catch (error) {
      console.error("CDD SAVE ERROR:", error);

      toast.error("❌ Failed to save CDD", {
        autoClose: 3000,
        theme: "colored",
      });
    }
  };

  return (
    <>
      <Layout>
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box">
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <a href="javascript:void(0);">IRC Ltd</a>
                        </li>
                        <li className="breadcrumb-item">
                          <a href="javascript:void(0);">Dashboards</a>
                        </li>
                        <li className="breadcrumb-item active">Welcome!</li>
                      </ol>
                    </div>
                    <h4 className="page-title">Welcome!</h4>
                  </div>
                </div>
              </div>

              {/* ===================== FORM START ===================== */}
              <div className="row justify-content-center mt-4">
                <div className="col-xxl-6 col-lg-8 col-md-10">
                  <div className="card shadow-sm border-0 rounded-3">
                    <div className="text-center mt-4">
                      {" "}
                      <Link
                        style={{ color: "white", marginTop: "1rem" }}
                        to="/outbound-challan"
                        className="btn btn-primary"
                      >
                        Outbound CDD Challan
                      </Link>
                    </div>
                    <div className="card-body p-4">
                      <div ref={formRef}>
	               <div
                        style={{
                          textAlign: "center",
                          padding: "15px 10px",
                          fontFamily: "Arial, Helvetica, sans-serif",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "32px",
                            fontWeight: "bold",
                            letterSpacing: "1px",
                          }}
                        >
                          IRC LIMITED
                        </div>

                        <div
                          style={{
                            fontSize: "20px",
                            fontWeight: "bold",
                            marginTop: "5px",
                          }}
                        >
                          IRC HOUSE, 1 SUNYAT SEN STREET , KOLKATA-700012
                        </div>

                        <div
                          style={{
                            fontSize: "18px",
                            marginTop: "8px",
                          }}
                        >
                          TELEPHONE NO. : +91-33-2236-5110 (5 Lines) FAX:
                          +91-33-2225 5936, Email : ho@ircl.in
                        </div>

                        <div
                          style={{
                            fontSize: "18px",
                            marginTop: "5px",
                          }}
                        >
                          PAN NO : AACCP2218A &nbsp;&nbsp;&nbsp; TAN: CALP02108B
                          &nbsp;&nbsp;&nbsp; GSTIN: 19AACCP2218A1ZY
                        </div>
                      </div>

                      <div style={{ padding: "20px", fontFamily: "Arial" }}>
                        <h2
                          style={{
                            textAlign: "center",
                            marginBottom: "10px",
                            textTransform: "uppercase",
                          }}
                        >
                          Commodity Delivery Document
                        </h2>
                        {/* ref start */}
                        <div ref={formRef}>
                          <form onSubmit={handleSubmit}>
                            {/* Serial Number Row */}
                            <table style={tableHeaderStyle}>
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>CDD No.</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="cddNo"
                                      value={formdata.cddNo}
                                      onChange={handleChange}
                                      readOnly
                                    />
                                  </td>

                                  <td>
                                    <strong>Date</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="date"
                                      className="form-control"
                                      id="Date"
                                      value={formdata.Date}
                                      onChange={handleChange}
                                      readOnly
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            {/* Warehouse Details */}
                            <h3>Warehouse Details</h3>
                            <table style={sectionStyle}>
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>Warehouse Name</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="WarehouseName"
                                      className="form-control"
                                      value={formdata.WarehouseName}
                                      onChange={handleChange}
                                      readOnly
                                    />
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <strong>Warehouse Address</strong>
                                  </td>
                                  <td colSpan="3">
                                    <input
                                      type="text"
                                      id="WarehouseAddress"
                                      className="form-control"
                                      value={formdata.WarehouseAddress}
                                      onChange={handleChange}
                                      readOnly
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            {/* Client Details */}
                            <h3>Client Details</h3>
                            <table style={sectionStyle}>
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>Client Name</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="ClientName"
                                      className="form-control"
                                      value={formdata.ClientName}
                                      onChange={handleChange}
                                      readOnly
                                    />
                                  </td>

                                  <td>
                                    <strong>Client Address</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="ClientAddress"
                                      className="form-control"
                                      value={formdata.ClientAddress}
                                      onChange={handleChange}
                                      readOnly
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            {/* Receipent Details */}
                            <h3>Receipent Details</h3>
                            <table style={sectionStyle}>
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>Name of Receipent</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="NameofReceipent"
                                      className="form-control"
                                      value={formdata.NameofReceipent}
                                      onChange={handleChange}
                                      readOnly
                                    />
                                  </td>

                                  <td>
                                    <strong>Proof Type</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="recepientProof"
                                      className="form-control"
                                      value={formdata.recepientProof}
                                      onChange={handleChange}
                                    />
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <strong>ID No.</strong>
                                  </td>
                                  <td colSpan="3">
                                    <input
                                      type="text"
                                      id="IdNo"
                                      className="form-control"
                                      value={formdata.IdNo}
                                      onChange={handleChange}
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            {/* Commodity Details */}
                            <h3>Commodity Details</h3>
                            <table style={sectionStyle}>
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>Name of Commodity</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="commodityName"
                                      className="form-control"
                                      value={formdata.commodityName}
                                      onChange={handleChange}
                                      readOnly
                                    />
                                  </td>

                                  <td>
                                    <strong>Variety</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="variety"
                                      className="form-control"
                                      value={formdata.variety}
                                      onChange={handleChange}
                                      readOnly
                                    />
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <strong>CDD No.</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="cddNo"
                                      className="form-control"
                                      value={formdata.cddNo}
                                      onChange={handleChange}
                                      readOnly
                                    />
                                  </td>

                                  <td>
                                    <strong>DO No.</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="DoNo"
                                      className="form-control"
                                      value={formdata.DoNo}
                                      onChange={handleChange}
                                      readOnly
                                    />
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <strong>DO Date</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="date"
                                      id="DoDate"
                                      className="form-control"
                                      value={formdata.DoDate}
                                      onChange={handleChange}
                                      readOnly
                                    />
                                  </td>

                                  <td>
                                    <strong>No. of Pack</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="NoOfPack"
                                      className="form-control"
                                      value={formdata.NoOfPack}
                                      onChange={handleChange}
                                      readOnly
                                    />
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <strong>Weighment (MT)</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="weighment"
                                      className="form-control"
                                      value={formdata.weighment}
                                      onChange={handleChange}
                                      readOnly
                                    />
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <strong>Gate Pass No.</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="gatePassNo"
                                      className="form-control"
                                      value={formdata.gatePassNo}
                                      onChange={handleChange}
                                      readOnly
                                    />
                                  </td>

                                  <td>
                                    <strong>Weigh Bridge Name</strong>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      id="weighBridgeName"
                                      className="form-control"
                                      value={formdata.weighBridgeName}
                                      onChange={handleChange}
                                      readOnly
                                    />
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <strong>Client Name (Signatory)</strong>
                                  </td>
                                  <td colSpan="3">
                                    <input
                                      type="text"
                                      id="clientName"
                                      className="form-control"
                                      value={formdata.clientName}
                                      onChange={handleChange}
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <h3>Truck Details</h3>

                            <table style={sectionStyle}>
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>Truck No</th>
                                  <th>Weight / Truck</th>
                                  <th>No of Bags</th>
                                </tr>
                              </thead>

                              <tbody>
                                {kataSlips.length === 0 ? (
                                  <tr>
                                    <td
                                      colSpan="4"
                                      style={{ textAlign: "center" }}
                                    >
                                      No truck data found
                                    </td>
                                  </tr>
                                ) : (
                                  kataSlips.map((item, index) => (
                                    <tr key={item.id || index}>
                                      <td>{index + 1}</td>

                                      {/* 🔹 adjust field names if needed */}
                                      <td>
                                        {item.vehicleNo || item.vehicleNo || ""}
                                      </td>

                                      <td>
                                        {item.weight_per_truck ||
                                          item.weight ||
                                          item.netWt ||
                                          ""}
                                      </td>

                                      <td>
                                        {item.no_of_bags || item.noOfBags || ""}
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>

                            {/* Remarks */}
                            <h3>Remarks</h3>
                            <textarea
                              id="Remarks"
                              className="form-control"
                              rows={4}
                              value={formdata.Remarks}
                              onChange={handleChange}
                            />

                            {/* Signature Section */}
                            <div style={signAreaStyle}>
                              <div style={signBlockStyle}>
                                <h4>
                                  Signature of Client / Authorised
                                  Representative
                                </h4>
                                <p>
                                  <strong>Name:</strong>
                                </p>
                                <p>
                                  <strong>Designation:</strong>
                                </p>
                                <p>
                                  <strong>Signature:</strong>
                                </p>
                              </div>

                              <div style={signBlockStyle}>
                                <h4>Warehouse Executive Signature</h4>
                                <p>
                                  <strong>Name:</strong>
                                </p>
                                <p>
                                  <strong>Designation:</strong>
                                </p>
                                <p>
                                  <strong>Signature:</strong>
                                </p>
                              </div>
                            </div>
		           

                            {/* ================= Truck Details from Kata Slip ================= */}

                            <div className="text-center mt-4">
                              <button type="submit" className="btn btn-primary">
                                Save CDD
                              </button>
                            </div>
                          </form>
                        </div>
                        </div>
                        {/* ref end */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ===================== FORM END ===================== */}
            </div>
          </div>
        </div>
        <ToastContainer />
      </Layout>
    </>
  );
};

/* ------------------- STYLES ------------------- */

const tableHeaderStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginBottom: "15px",
  border: "1px solid #000",
};

const sectionStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginBottom: "15px",
};

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginBottom: "20px",
};

const signAreaStyle = {
  marginTop: "30px",
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
};

const signBlockStyle = {
  width: "48%",
};

/* Apply borders globally */
const applyBorders = `
  table td, table th {
    border: 1px solid #000;
    padding: 6px;
  }
`;

// Inject border CSS
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = applyBorders;
document.head.appendChild(styleSheet);

export default DoForm2;

